import apiClient from './client';

export type ClientReportType = 'PAYMENT_ISSUE' | 'GENERAL_OTHER' | 'ONBOARDING_ADDITIONAL_INFO' | string;

export type ClientReportStatus = 'OPEN' | 'IN_PROGRESS' | 'RESOLVED' | 'CLOSED';

export interface ClientSupportReport {
  id: string;
  clientId: string;
  reportType: string;
  outgoingPaymentId?: string | null;
  outgoingPaymentStatus?: string | null;
  outgoingPaymentReference?: string | null;
  outgoingPaymentAmount?: number | null;
  outgoingPaymentCurrency?: string | null;
  description: string;
  status: string;
  adminNote?: string | null;
  createdAt: string;
  updatedAt: string;
  /** Present when ticket is tied to an onboarding application */
  onboardingApplicationId?: string | null;
}

export interface UpdateClientSupportReportBody {
  status: ClientReportStatus | string;
  adminNote?: string | null;
}

export interface ClientReportMessage {
  id: string;
  reportId: string;
  senderType: 'CLIENT' | 'ADMIN';
  senderAdminId?: string | null;
  senderDisplayName?: string | null;
  body: string;
  createdAt: string;
}

export const clientReportsApi = {
  listAdmin: (params?: { limit?: number; status?: string; clientId?: string }) =>
    apiClient.get<ClientSupportReport[]>('/Reports/admin', { params }),

  getAdmin: (id: string) => apiClient.get<ClientSupportReport>(`/Reports/admin/${id}`),

  updateAdmin: (id: string, body: UpdateClientSupportReportBody) =>
    apiClient.patch(`/Reports/admin/${id}`, body),

  getMessages: (id: string) =>
    apiClient.get<ClientReportMessage[]>(`/Reports/admin/${id}/messages`),

  reply: (id: string, body: string) =>
    apiClient.post(`/Reports/admin/${id}/reply`, { body }),
};
